module.exports = __webpack_public_path__ + "static/media/Calendar.c48e1d89.md";